var _defs, _g, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStepsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2525ed69f0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2525ed69f0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fdfbf9",
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 10.417969 22.460938 C 8.433594 22.992188 6.519531 22.296875 7.136719 24.582031 C 7.75 26.867188 9.855469 28.289062 11.839844 27.757812 C 13.824219 27.226562 14.933594 24.945312 14.320312 22.660156 C 13.707031 20.375 12.398438 21.929688 10.417969 22.460938 Z M 10.417969 22.460938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 10.03125 21.050781 C 13.761719 20.050781 12.792969 18.796875 13.203125 16.304688 C 13.585938 13.972656 10.273438 6.8125 6.476562 7.828125 C 2.675781 8.847656 3.425781 16.675781 4.90625 18.527344 C 6.542969 20.574219 6.300781 22.046875 10.03125 21.050781 Z M 10.03125 21.050781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 19.613281 16.382812 C 17.628906 15.851562 16.324219 14.296875 15.707031 16.582031 C 15.09375 18.867188 16.203125 21.148438 18.1875 21.679688 C 20.171875 22.210938 22.277344 20.789062 22.894531 18.503906 C 23.507812 16.21875 21.597656 16.914062 19.613281 16.382812 Z M 19.613281 16.382812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 23.554688 1.753906 C 19.757812 0.738281 16.441406 7.894531 16.828125 10.230469 C 17.238281 12.71875 16.269531 13.972656 20 14.972656 C 23.726562 15.96875 23.484375 14.5 25.125 12.449219 C 26.605469 10.597656 27.351562 2.769531 23.554688 1.753906 Z M 23.554688 1.753906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepsIcon);
export default __webpack_public_path__ + "static/media/steps-icon.155cd0b27e0aed48c98f985d0c6b1ce9.svg";
export { ForwardRef as ReactComponent };